export default "__VITE_ASSET__CFwOh5bj__"